var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFileChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2701 9H11.067C10.867 9 10.667 9.2 10.667 9.4V13.6031C10.667 13.8 10.867 14 11.067 14H12.2701C12.467 14 12.667 13.8 12.667 13.6031V9.4C12.667 9.2 12.467 9 12.2701 9ZM6.27012 11H5.06699C4.86637 11 4.66699 11.2 4.66699 11.4V13.6031C4.66699 13.8 4.86637 14 5.06543 14H6.26855C6.46699 14 6.66699 13.8 6.66699 13.6031V11.4C6.66699 11.2 6.46699 11 6.27012 11ZM9.27012 7H8.06699C7.86699 7 7.66699 7.2 7.66699 7.4V13.6031C7.66699 13.8 7.86699 14 8.06699 14H9.27012C9.46699 14 9.66699 13.8 9.66699 13.6031V7.4C9.66699 7.2 9.46699 7 9.27012 7ZM10.667 0V4H14.667L10.667 0Z",
    fill: "#304A5C",
    className: "fill-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.667 4V0H4.16699C3.33855 0 2.66699 0.671562 2.66699 1.5V14.5C2.66699 15.3281 3.33855 16 4.16699 16H13.167C13.9954 16 14.667 15.3284 14.667 14.5V4H10.667ZM6.66699 13.6031C6.66699 13.8 6.46699 14 6.27012 14H5.06699C4.86637 14 4.66699 13.8 4.66699 13.6031V11.4C4.66699 11.2 4.86637 11 5.06543 11H6.26855C6.46699 11 6.66699 11.2 6.66699 11.4V13.6031ZM9.66699 13.6031C9.66699 13.8 9.46699 14 9.27012 14H8.06699C7.86699 14 7.66699 13.8 7.66699 13.6031V7.4C7.66699 7.2 7.86699 7 8.06699 7H9.27012C9.46699 7 9.66699 7.2 9.66699 7.4V13.6031ZM12.667 13.6031C12.667 13.8 12.467 14 12.2701 14H11.067C10.867 14 10.667 13.8 10.667 13.6031V9.4C10.667 9.2 10.867 9 11.067 9H12.2701C12.467 9 12.667 9.2 12.667 9.4V13.6031Z",
    fill: "#304A5C",
    className: "fill-secondary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileChart);
export default __webpack_public_path__ + "static/media/ico-file-chart.aa9334e42c0fa7a12e0a08e60f708231.svg";
export { ForwardRef as ReactComponent };